import React from 'react'

/**
 * Indeterminate spinner in the brand colour. Used for page-level loading
 * states and inline "saving…" indicators inside buttons.
 *
 * Size defaults to 24px; pass `size="sm"` for inline use (16px).
 */
export interface SpinnerProps {
  size?: 'sm' | 'md'
  className?: string
  label?: string
}

export function Spinner({ size = 'md', className = '', label = 'Loading' }: SpinnerProps) {
  const dim = size === 'sm' ? 'w-4 h-4 border-2' : 'w-6 h-6 border-2'
  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block ${dim} border-brand-600 border-t-transparent rounded-full animate-spin-slow ${className}`}
    />
  )
}

/**
 * Full-panel centered spinner — use as the loading state of a whole page.
 */
export function PageSpinner() {
  return (
    <div className="flex items-center justify-center py-20">
      <Spinner />
    </div>
  )
}
